<template>
  <v-container class="mt-2 pr-2" fluid>
    <v-row>
      <v-col cols="12">
	      <v-card class="shadowCard">
	        <v-card-title primary-title >
	          Catálogo de alumnos

	          <v-spacer></v-spacer>
	          
	          <v-btn 
		          class="mr-2" 
		          small dark color="green"
		          @click="exportExcel( niveles  , 'escuelas_ERP')"
		          tile
		        >
		          <v-icon small>mdi-microsoft-excel</v-icon>
		        </v-btn>

		        <v-btn
		          color="primary"
		          dark
		          class="mr-2"
		          @click="dialog = true"
		          small
		          tile
		        >
		          <v-icon small>mdi-plus</v-icon>
		        </v-btn>

		        <v-btn
		          color="orange"
		          dark
		          class="text-capitalize"
		          @click="initialize()"
		          small
		          tile
		        >
		          <v-icon small>mdi-refresh</v-icon>
		        </v-btn>

	        </v-card-title>

	        <v-card-text>
	          <v-row justify="end">

				  		<v-col cols="12" md="4">
		          	<v-autocomplete 
	                class="mb-4"
	                v-model="idplanteles" 
	                :items="planteles" 
	                filled 
	                append-icon="mdi-clipboard-account"
	                label="Plantel" 
	                hide-details 
	                single-line
	                clearable
	                dense 
	                item-text="plantel" 
	                item-value="id_plantel"
	              ></v-autocomplete>
	            </v-col>


				  		<v-col cols="12" md="8">
				  			<v-text-field
				  			  name="name"
				  			  label="Buscar"
				  			  id="id"
				  			  filled
				  			  dense
                  single-line
				  			  hide-details
				  			  append-icon="mdi-magnify"
				  			  v-model="search"
				  			>
				  			</v-text-field>
				  		</v-col>
				  	</v-row>

				  	<v-row>
			    		<v-col cols="12">

			          <v-data-table
			            :loading="cargar"        
			            :headers="headers"
			            :items="filterAlumnos"
			            fixed-header
			            cargar-text="Cargando..."
			            dense
			            :search="search"
			          >
			            <template v-slot:item.nivel="{ item }" >
			              {{ item.nivel === 'USUARIO'? 'Usuario':'Administrador'}}    
			            </template>

			            <template v-slot:item.sexo="{ item }" >
			              {{ item.sexo == 1 ? 'H':'M'}}    
			            </template>


			            <template v-slot:item.estatus="{ item }" >
			              <v-chip small  dark :color="item.estatus ? 'green' : 'red'">ACTIVO</v-chip>
			            </template>

			            <template v-slot:item.actions="{ item }" >
			              <v-icon
			                small
			                class="mr-2"
			                @click="editItem(item)"
			              >
			                mdi-pencil
			              </v-icon>

									  <v-icon 
		  						    small 
		  						    class="mr-2"
		  						    @click="handleDocumento(item)"
		  						    :color="item.tiene_documentos ? 'primary' : 'amber'"
		  						    :title="item.tiene_documentos ? 'Ver documento' : 'Subir documento'"
		  						  >
		  						    {{ item.tiene_documentos ? 'mdi-file-document-outline' : 'mdi-file-upload-outline' }}
		  						  </v-icon>

			              <v-icon small @click="deleteItem(item)" color="error">
                      mdi-delete
                    </v-icon>
			            </template>

									<template v-slot:item.foto="{ item }">
									  <v-avatar size="40">
									    <v-img v-if="item.foto && item.foto !== '' && url" :src="`${url}/${item.foto}`"></v-img>
									    <v-icon v-else size="40" color="grey lighten-1">mdi-account-circle</v-icon>
									  </v-avatar>
									</template>

			          </v-data-table>
			        </v-col>
			      </v-row>
	        </v-card-text>
	              
	      </v-card>
	    </v-col>
    </v-row>  

    <v-row justify="center">
      <v-dialog v-model="modal" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Eliminar Usuario</v-card-title>
          <v-card-text>¿Deseas eliminar permanentemente el usuario?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="modal = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="deleteUsuario">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text class="px-0">
          <v-form 
          	class="my-0"
            ref="form" 
            v-model="valid"
            :lazy-validation="lazy"
          >
            <v-card-text>

            	<v-row>
            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.nombres" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Nombre" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.apellido_paterno" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Apellido paterno" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.apellido_materno" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Apellido materno" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.edad" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Edad" 
		                type="number"
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.telefono" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Teléfono"
		                type="number" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.telefono_emergencias" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Teléfono Emergencias"
		                type="number" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.fecha_nacimiento" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Fecha de nacimiento"
		                type="date" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.lugar_nacimiento" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Lugar de nacimiento"
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="4">
	            		<v-autocomplete 
		                class="mb-4"
		                v-model="editedItem.idplanteles" 
		                :items="planteles" 
		                filled 
		                append-icon="mdi-clipboard-account"
		                label="Plantel" 
		                hide-details 
		                dense 
		                item-text="plantel" 
		                item-value="id_plantel"
		              ></v-autocomplete>
		            </v-col>

            		<v-col cols="12" md="6">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.correo" 
		                color="secondary"
		                clearable
		                hide-details 
		                append-icon="mdi-account" 
		                label="Correo" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="6">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.password" 
		                color="secondary"
		                clearable
		                hide-details 
		                append-icon="mdi-account" 
		                label="Contraseña" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

								<v-col cols="12" md="12">
								  <v-card outlined class="pa-3">
								    <div class="d-flex flex-column align-center">
										<v-avatar size="150" class="mb-3">
										  <v-img v-if="editedItem.foto && editedItem.foto !== ''" :src="`${this.url}/${editedItem.foto}`"></v-img>
										  <v-icon v-else size="150" color="grey lighten-1">mdi-account-circle</v-icon>
										</v-avatar>
								  
								      <v-file-input
								        v-model="fotoPerfil"
								        accept="image/*"
								        label="Foto de perfil"
								        prepend-icon="mdi-camera"
								        @change="previewFoto"
								        hide-details
								        dense
								        class="mt-2"
								        :clearable="true"
								      ></v-file-input>
								    </div>
								  </v-card>
								</v-col>

            	</v-row>

            	<v-divider></v-divider>
            	<label>Dirección del alumno</label>
            	<v-row>
            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.calle" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Calle" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.numero" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Número" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.colonia" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Colonia" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.municipio" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Municipio" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>
            	</v-row>

            	<v-divider></v-divider>
            	<label>Datos del tutor</label>
            	<v-row>
            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.estado_civil" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Estado civil" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="8">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.nombre_tutor" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Nombre del tutor" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.telefono_tutor" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Teléfono del tutor" 
		                filled dense 
		                required
		                type="number"
		                class="mb-4"
		              ></v-text-field>
            		</v-col>

            		<v-col cols="12" md="4">
		              <v-text-field 
		                :rules="nameRules"
		                v-model="editedItem.ocupacion" 
		                color="secondary"
		                clearable
		                hide-details 
		                label="Ocupación" 
		                filled dense 
		                required
		                class="mb-4"
		              ></v-text-field>
            		</v-col>
            	</v-row>
            </v-card-text>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="black"
            dark
            small
            @click="close"
            tile
            dense
          >
          	<v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            small
            dark
            @click="save"
            tile
          >
          	<v-icon left small>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

	<!-- Diálogo para visualizar documento -->
	<v-dialog v-model="documentoDialog" max-width="900px" persistent>
	  <v-card>
	    <v-card-title class="headline" style="background-color: #f5f5f5;">
	      <v-icon left color="primary">mdi-file-document-outline</v-icon>
	      Documentos de Alumno
	      <v-spacer></v-spacer>
	      <v-btn icon @click="documentoDialog = false">
	        <v-icon>mdi-close</v-icon>
	      </v-btn>
	    </v-card-title>
	    <v-card-text>
	      <v-row>
	        <v-col cols="12" md="4">
	          <v-list dense>
	            <v-subheader>Documentos disponibles</v-subheader>
	            <v-list-item
	              v-for="(doc, index) in documentos"
	              :key="doc.id"
	              @click="seleccionarDocumento(doc)"
	              :class="{ 'v-list-item--active': selectedDocumentoId === doc.id }"
	            >
	              <v-list-item-avatar>
	                <v-icon>mdi-file-pdf-box</v-icon>
	              </v-list-item-avatar>
	              <v-list-item-content>
	                <v-list-item-title>{{ doc.nombre_documento }}</v-list-item-title>
	                <v-list-item-subtitle>{{ formatFecha(doc.fecha_subida) }}</v-list-item-subtitle>
	              </v-list-item-content>
	              <v-list-item-action>
	                <v-btn icon small @click.stop="confirmarEliminacion(doc)">
	                  <v-icon color="error">mdi-delete</v-icon>
	                </v-btn>
	              </v-list-item-action>
	            </v-list-item>
	          </v-list>
	        </v-col>
	        <v-col cols="12" md="8">
	          <iframe
	            v-if="pdfUrl"
	            :src="pdfUrl"
	            style="width: 100%; height: 70vh; border: none;"
	          ></iframe>
	          <div v-else class="text-center pa-5">
	            <p>Seleccione un documento para visualizarlo</p>
	          </div>
	        </v-col>
	      </v-row>
	    </v-card-text>
	    <v-card-actions>
	      <v-btn
	        color="primary"
	        text
	        @click="uploadDialog = true; documentoDialog = false"
	      >
	        <v-icon left>mdi-file-upload-outline</v-icon>
	        Subir más documentos
	      </v-btn>
	      <v-spacer></v-spacer>
	      <v-btn
	        color="primary"
	        text
	        @click="documentoDialog = false"
	      >
	        Cerrar
	      </v-btn>
	    </v-card-actions>
	  </v-card>
	</v-dialog>

	<!-- Diálogo para confirmar eliminación de documento -->
	<v-dialog v-model="confirmDeleteDialog" max-width="400px">
	  <v-card>
	    <v-card-title class="headline">Eliminar documento</v-card-title>
	    <v-card-text>
	      ¿Está seguro que desea eliminar este documento? Esta acción no se puede deshacer.
	    </v-card-text>
	    <v-card-actions>
	      <v-spacer></v-spacer>
	      <v-btn color="primary" text @click="confirmDeleteDialog = false">
	        Cancelar
	      </v-btn>
	      <v-btn color="error" text @click="eliminarDocumento">
	        Eliminar
	      </v-btn>
	    </v-card-actions>
	  </v-card>
	</v-dialog>

	<v-dialog v-model="uploadDialog" max-width="500px" persistent>
	  <v-card>
	    <v-card-title class="headline" style="background-color: #f5f5f5;">
	      <v-icon left color="primary">mdi-file-upload-outline</v-icon>
	      Subir documentos
	      <v-spacer></v-spacer>
	      <v-btn icon @click="uploadDialog = false">
	        <v-icon>mdi-close</v-icon>
	      </v-btn>
	    </v-card-title>
	    <v-card-text class="pt-5">
	      <v-file-input
	        v-model="documentoFiles"
	        label="Seleccionar documentos"
	        placeholder="Seleccione uno o más archivos PDF"
	        prepend-icon="mdi-file-document-outline"
	        outlined
	        multiple
	        accept=".pdf"
	        :show-size="1000"
	        counter
	        hint="Solo archivos PDF. Máximo 10MB por archivo."
	      ></v-file-input>
	    </v-card-text>
	    <v-card-actions>
	      <v-spacer></v-spacer>
	      <v-btn
	        color="primary"
	        text
	        @click="uploadDialog = false"
	      >
	        Cancelar
	      </v-btn>
	      <v-btn
	        color="primary"
	        @click="uploadDocumento"
	        :disabled="!documentoFiles || documentoFiles.length === 0"
	      >
	        Subir
	      </v-btn>
	    </v-card-actions>
	  </v-card>
	</v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>


<script>
  var md5     = require('md5')
  import XLSX from 'xlsx'

  import axios from 'axios';

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {
    components:{
      Alerta,
      carga,
    },

    mixins:[ validarErrores ],

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

	  documentoDialog: false,
  	  uploadDialog: false,
  	  currentAlumno: null,
  	  documentoFiles: [],
  	  pdfUrl: null,

	  url: '',


	  documentos: [],
  	  selectedDocumentoId: null,
  	  confirmDeleteDialog: false,
  	  documentoAEliminar: null,

	  fotoPerfil: null,
	  previewImage: null,

      headers: [
	    { text: 'Foto', value: 'foto', sortable: false, align: 'center' },
        { text: 'ID'          , value: 'idalumnos'          },
        { text: 'Matricula'   , value: 'matricula'          },
        { text: 'Nombre'      , value: 'nombre_completo'    },
        { text: 'Edad'        , value: 'edad'               },
        { text: 'Sexo'        , value: 'sexo'               },
        { text: 'Teléfono'    , value: 'telefono'           },
        { text: 'Correo'      , value: 'correo'             },
        { text: 'Fecha alta'  , value: 'fecha_creacion'     },  
        { text: 'Plantel'     , value: 'plantel'            },  
        { text: 'Actions'     , value: 'actions'            },  
      ],

      search: '',
      alumnos: [],

      modal: false,
      ideliminar:0,

      dialog: false,
			editedIndex: -1,
      editedItem: {
        idalumnos: null,
        nombres:'',
        apellido_paterno:'',
        apellido_materno:'',
        edad:'',
        sexo:'',
        telefono:'',
        correo:'',
        password:'',
        foto:'',
        estatus:0,
        fecha_creacion:null,
        delted:null,
        calle:'',
        numero:0,
        colonia:'',
        municipio: '',
        telefono_emergencias: '',
        fecha_nacimiento:null,
        estado_civil: null,
        lugar_nacimiento:'',
        nombre_tutor:'',
        telefono_tutor:'',
        ocupacion:'',
        facebook:'', 
      },
      defaultItem: {
        idalumnos: null,
        nombres:'',
        apellido_paterno:'',
        apellido_materno:'',
        edad:'',
        sexo:'',
        telefono:'',
        correo:'',
        password:'',
        foto:'',
        estatus:0,
        fecha_creacion:null,
        delted:null,
        calle:'',
        numero:0,
        colonia:'',
        municipio: '',
        telefono_emergencias: '',
        fecha_nacimiento:null,
        estado_civil: null,
        lugar_nacimiento:'',
        nombre_tutor:'',
        telefono_tutor:'',
        ocupacion:'',
        facebook:'', 
      },

      valid:true,
      lazy: false,

      show: false,
      show1: false,
      show2: false,
      passwordActual:'',
      cambiaPassword:true,

      admin:{ clave:'', nombre:''},
      niveles: [{clave:'ADMIN', nombre:'Administrador'},{clave:'USUARIO',nombre:'Usuario'},{clave:'SUPERVISOR',nombre:'Supervisor'}],
      password:'',
      password2:'',
			nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 60) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required'
      ],

      planteles:[],
      puestos:[], 
      idplanteles:null  
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo usuario' : 'Editar usuario'
      },

      filterAlumnos( ){

      	let data = this.alumnos

      	if( this.idplanteles ){

      		return data.filter( el => el.idplanteles == this.idplanteles )
      	}else{
      		return data
      	}



      }
    },

    async created() {
	  this.url = this.$http.options.root + 'uploads/fotos_perfil';
	  await this.initialize();
	  await this.getPlanteles();
	},

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    methods: {
      // Editar el usuario, se recibe como parametro el usuario
      editar(item){
        this.$router.push({name:'newusuario', params: {id: item.id}})
      },

      initialize () {
        this.cargar = true
        //Consultar alumnos
        this.alumnos = []
        this.$http.get('alumnos.list').then( response => {
          this.cargar = false
          this.alumnos = response.body
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },  

      getPlanteles () {
        this.cargar = true
        //Consultar alumnos
        this.planteles = []
        return this.$http.get('planteles.list.erp').then(response=>{
          this.cargar = false
          this.planteles = response.body
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },  



      deleteItem(item) {
	      this.editedIndex = this.alumnos.indexOf(item);
	      this.editedItem = Object.assign({}, item);
	      this.dialogDelete = true;
	    },

	    deleteItemConfirm() {
	      // Lo mandapos por el EP
	      this.editedItem.deleted = 1;
	      this.$http.put("alumnos.update/" + this.editedItem.idreglamento, this.editedItem ).then((response) => {
          this.dialogSuccess = true;
          this.cargar = false;
          this.closeDelete();
          this.initialize();
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
	    },

      deleteUsuario(){
        // Eliminar usuario
        this.$http.delete('alumnos.delete/' + this.ideliminar).then(response=>{
          this.text = 'Usuario eliminado correctamente'
          this.color = 'success'
          this.snackbar = true
          this.initialize()
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.alumnos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.passwordActual = this.editedItem.password
      },

      close () {
        this.dialog = false,
		this.fotoPerfil = null
  		this.previewImage = null
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save() {
	    this.cargar = true;
		  
	    const enviarDatos = () => {
	      if (this.editedIndex > -1) {
	        this.$http.put(`alumnos.update/${this.editedItem.idalumnos}`, this.editedItem).then(response => {
	          this.validarSuccess('Usuario actualizado correctamente');
	          this.close();
	          this.initialize(this.id);
	        }).catch(error => {
	          this.validarError(error);
	        }).finally(() => {
	          this.cargar = false;
	        });
	      } else {
	        this.$http.post('alumnos.add', this.editedItem).then(response => {
	          this.validarSuccess('Usuario agregado correctamente');
	          this.close();
	          this.initialize();
	        }).catch(error => {
	          this.validarError(error);
	        }).finally(() => {
	          this.cargar = false;
	        });
	      }
	    };
	    
	    // Si hay una nueva foto, subirla primero
	    if (this.fotoPerfil) {
	      const formData = new FormData();
	      formData.append('foto', this.fotoPerfil);
	  
	      // Si es actualización y tenemos ID de alumno
	      if (this.editedIndex > -1 && this.editedItem.idalumnos) {
	        this.$http.post(`alumnos.foto.upload/${this.editedItem.idalumnos}`, formData, {
	          headers: {
	            'Content-Type': 'multipart/form-data'
	          }
	        }).then(response => {
	          // Actualizar la foto en el objeto editedItem con la URL devuelta
	          this.editedItem.foto = response.body.foto_path || '';
	          // Continuar con el guardado del resto de los datos
	          enviarDatos();
	        }).catch(error => {
	          this.validarError(error);
	          this.cargar = false;
	        });
	      } else {
	        // Es un alumno nuevo, guardar primero los datos y luego la foto
	        enviarDatos();
	      }
	    } else {
	      // No hay foto nueva, solo guardar los datos
	      enviarDatos();
	    }
	  },

	  handleDocumento(item) {
	    this.currentAlumno = item;
		  
	    // Verificar documentos existentes
	    this.$http.get(`alumnos.documentos/${item.idalumnos}`)
	      .then(response => {
	        this.documentos = response.body;
		  
	        if (this.documentos && this.documentos.length > 0) {
	          // Si tiene documentos, mostrar diálogo de documentos
	          this.documentoDialog = true;
	          // Seleccionar el primer documento para visualizarlo
	          this.seleccionarDocumento(this.documentos[0]);
	        } else {
	          // Si no tiene documentos, mostrar diálogo de carga
	          this.uploadDialog = true;
	        }
	      })
	      .catch(error => {
	        console.error('Error al obtener documentos:', error);
	        // Si hay error, asumir que no hay documentos y mostrar diálogo de carga
	        this.uploadDialog = true;
	      });
	  },
      
	  uploadDocumento() {
		  
	    if (!this.documentoFiles || !this.documentoFiles.length || !this.currentAlumno) {
	      console.error('No hay archivos seleccionados o no hay alumno actual');
	      return;
	    }
	  
	    this.cargar = true;
	  
	    // Array para almacenar todas las promesas de subida
	    const uploadPromises = this.documentoFiles.map(file => {
	  
	      const formData = new FormData();
	      formData.append('documento', file);
	  	  
	      return this.$http.post(`alumnos.documento.upload/${this.currentAlumno.idalumnos}`, formData, {
	        headers: {
	          'Content-Type': 'multipart/form-data'
	        }
	      }).then(response => {
	        return response;
	      }).catch(error => {
	        console.error('Error al subir el archivo:', file.name, error);
	        throw error;
	      });
	    });
	  
	    // Ejecutar todas las subidas en paralelo
	    Promise.all(uploadPromises)
	      .then(responses => {
	        this.validarSuccess(`${this.documentoFiles.length} documento(s) subido(s) correctamente`);
	        this.uploadDialog = false;
	        this.documentoFiles = [];
		  
	        if (this.documentoDialog) {
	          this.fetchDocumentos(this.currentAlumno.idalumnos);
	        } else {
	          this.initialize();
	        }
	      })
	      .catch(error => {
	        console.error('Error en Promise.all:', error);
	        this.validarError(error);
	      })
	      .finally(() => {
	        this.cargar = false;
	      });
	  },
      

	  // Método para obtener los documentos del alumno
  	  async fetchDocumentos(alumnoId) {
  	    this.cargar = true;
  	    try {
  	      const response = await this.$http.get(`alumnos.documentos/${alumnoId}`);
  	      this.documentos = response.body;
  	      if (this.documentos.length > 0) {
  	        this.seleccionarDocumento(this.documentos[0]);
  	      }
  	    } catch (error) {
  	      this.validarError(error);
  	    } finally {
  	      this.cargar = false;
  	    }
  	  },
  	  
  	  // Método para seleccionar un documento y visualizarlo
  	  seleccionarDocumento(documento) {
  	    this.selectedDocumentoId = documento.id;
  	    this.pdfUrl = null;
  	    this.cargar = true;
	  
  	    this.$http.get(`alumnos.documento/${documento.id}`, {
		  responseType: 'blob'
		})
  	    .then(response => {
  	      const blob = new Blob([response.data], { type: 'application/pdf' });
  	      this.pdfUrl = window.URL.createObjectURL(blob);
  	    })
  	    .catch(error => {
  	      console.error('Error al cargar el documento:', error);
  	      this.validarError('Error al cargar el documento. Por favor, inténtelo de nuevo.');
  	    })
  	    .finally(() => {
  	      this.cargar = false;
  	    });
  	  },
  	  
  	  // Método para mostrar el diálogo de confirmación antes de eliminar
  	  confirmarEliminacion(documento) {
  	    this.documentoAEliminar = documento;
  	    this.confirmDeleteDialog = true;
  	  },
  	  
  	  // Método para eliminar el documento seleccionado
  	  eliminarDocumento() {
  	    if (!this.documentoAEliminar) return;
	  
  	    this.cargar = true;
	  
  	    this.$http.delete(`alumnos.documento/${this.documentoAEliminar.id}`)
  	      .then(response => {
  	        this.validarSuccess('Documento eliminado correctamente');
  	        // Eliminar el documento de la lista local
  	        const index = this.documentos.findIndex(d => d.id === this.documentoAEliminar.id);
  	        if (index !== -1) this.documentos.splice(index, 1);
		  
  	        // Resetear visualización si no quedan documentos
  	        if (this.documentos.length === 0) {
  	          this.pdfUrl = null;
  	          this.selectedDocumentoId = null;
  	        } else if (this.selectedDocumentoId === this.documentoAEliminar.id) {
  	          // Si se eliminó el documento que se estaba visualizando, mostrar otro
  	          this.seleccionarDocumento(this.documentos[0]);
  	        }
		  
  	        this.confirmDeleteDialog = false;
  	        this.documentoAEliminar = null;
  	      })
  	      .catch(error => {
  	        console.error('Error al eliminar el documento:', error);
  	        this.validarError('Error al eliminar el documento. Por favor, inténtelo de nuevo.');
  	      })
  	      .finally(() => {
  	        this.cargar = false;
  	      });
  	  },

	  previewFoto(file) {
	    if (!file) {
	      this.previewImage = null;
	      return;
	    }
	    
	    // Crear URL temporal para previsualizar la imagen
	    this.previewImage = URL.createObjectURL(file);
	  },

	  getImageUrl(filename) {
    if (!filename) return '';
    return `${this.$http.options.root}uploads/fotos_perfil/${filename}`;
  },
  	  
  	  // Método para dar formato a la fecha
  	  formatFecha(fecha) {
  	    if (!fecha) return '';
  	    const date = new Date(fecha);
  	    return date.toLocaleDateString('es-MX', { 
  	      year: 'numeric', 
  	      month: 'short', 
  	      day: 'numeric',
  	      hour: '2-digit',
  	      minute: '2-digit'
  	    });
  	  },

    },

  }
</script>